import { $ } from '../../../shared/js/utils/dom';

const link = $('.nav-to-top__link');
const href = link?.href.split('#')[1];
const target = $(`#${href}`);
const clickHandler = e => {
  e.preventDefault();
  target.focus();
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: window.matchMedia('(prefers-reduced-motion)').matches
      ? 'instant'
      : 'smooth',
  });
};

link?.addEventListener('click', clickHandler);
